import { ProcessRoleOutputDTO } from '@types';

export const processRoleMapper = {
  toDTO: (
    data: Partial<ProcessRoleOutputDTO>
  ): Partial<ProcessRoleOutputDTO> => {
    return {
      ...data,
      additionalData: data.additionalData?.map((field) => ({
        ...field,
      })),
    };
  },

  toView: (data: ProcessRoleOutputDTO): ProcessRoleOutputDTO => {
    return data; // Por enquanto retorna o mesmo objeto, podemos expandir se necessário
  },
};
